<template>
  <div  id="noon-form-long-text">
    <vs-row vs-w="12">
      <vs-col vs-justify="flex-start" vs-align="center" vs-w="12">
        <div class="aisea-text-14-400-gray">{{ form.label }}</div>
        <vs-textarea v-model="inputValue"/>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

import {DeviceInfoMixin, ColorMixin} from "@/mixins";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    form: {type: Object, required: true},
    value: {required: false}
  }, data() {
    return {
      inputValue: '',
    }
  },
  watch: {
    inputValue: {
      handler (val) {
        const payload = {
          id: this.form.id,
          label: val,
          value: val,
          isAlert: this.isAlert
        };
        this.$emit("setValue", payload)
      },
      deep: true,
    },
  },
  computed: {
    isAlert () {
      return false;
    }
  },
  methods: {},
  mounted() {
    if (this.value) {
      this.inputValue = this.value;
    } else if(this.form.default_value) {
      this.inputValue = this.form.default_value;
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

#noon-form-long-text {
  textarea {
    font-size: 1.2rem !important;
    color: #626262;
    padding: 12px;
  }
  textarea:focus {
    border: 1px solid $aisea-blue !important;
    box-shadow: 0 3px 10px 0 #ccc;
  }
}

</style>
